
import { Component, Prop, Vue } from "vue-property-decorator";
import {  MstCommonCodeVO } from "@/views/biz/order/vo/order.vo";
import CommonModalDialog from "@/components/CommonModalDialog.vue";
import DeliveryAddressChoicePop from "./DeliveryAddressChoicePop.vue";
import { MstOrderVO,  } from "./vo/order.vo";
import axios from "axios";

@Component({
    components: {DeliveryAddressChoicePop, CommonModalDialog}
})
export default class DeliveryAddressChange extends Vue {
   @Prop() orderInfo!: MstOrderVO;


  //배송요청사항 직접입력,시향지
  showMemo = false;
  orderMemo = { code: "", codeNm: "" };
  commonCodes: Array<MstCommonCodeVO> = [] as Array<MstCommonCodeVO>; // 공통코드 (배송요청사항))
  orderNumber = 0 as number;
  showAddressChoicePop = false;
  memoCopy = "" as string;

  // init
  mounted() {

    // 주문번호 없으면 마운트 금지
    this.orderNumber = this.orderInfo?.orderCd;
    if(!this.orderNumber || this.orderNumber == 0){
      this.$router.go(-1);
    }
    axios.get('/mypage/order/detail/shipment')
    .then((r) => {
      this.commonCodes = r.data
      
      if(this.orderInfo.memo){
      let tempCode = r.data.filter((val)=> {return val.commNm == this.orderInfo.memo})[0];

      // 직접입력 / 시향지 일때 그냥 직접입력문구로 통일 후 메시지 보이기
      if(tempCode == null){
        tempCode = r.data[r.data.length-1];
        this.showMemo = true;
        this.memoCopy = this.orderInfo.memo;

      }

      // 필터링된 데이터를 orderMemo에 대입
      this.orderMemo.code = tempCode.commCd;
      this.orderMemo.codeNm = tempCode.commNm;
      }
     
    })
  }
    // 주소 변경
  saveAddress(): void {
    if (!confirm(this.$t("order.c0003").toString())) {
      // 배송 정보를 변경하시겠습니까?
      return;
    }

    if(this.memoCopy != this.orderInfo.memo){
      this.orderInfo.memo = this.memoCopy
    }
    axios.put("/order/address", this.orderInfo).then(() => {
      this.$toast(this.$t("order.a0027"));
      this.$router.push({name:"OrderDetails", params:{ orderCd : this.orderInfo.orderCd.toString()}});
    });
  }
    //배송요청사항 변경
  orderMemoChange(memo: any): void {
    if (memo.code == "041005" || memo.code == "041006") {
      this.memoCopy = "";
      this.showMemo = true;

    } else {
      this.showMemo = false;
      this.memoCopy = memo.codeNm;

    }

  }
    
}
